import { FormApi } from 'final-form'
import React from 'react'

import FormContext from './FormContext'

type TFormContextProvider = {
  children?: React.ReactNode
  form?: FormApi
}

const FormContextProvider = (
  props: TFormContextProvider,
): React.ReactElement => {
  const { children, form } = props

  return (
    <FormContext.Provider value={{ form }}>{children}</FormContext.Provider>
  )
}

export default FormContextProvider
